var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:['text-secondary', {
  'text-success': _vm.value >= 0,
  'text-danger': _vm.value < 0,
}]},[_vm._v(" "+_vm._s(_vm.value.toFixed(_vm.precision))+" "+_vm._s(_vm.legend))])
}
var staticRenderFns = []

export { render, staticRenderFns }